const uploadScopeSelector = {
  metadataOptions: {
    projects: {
      label: "This project",
      description:
        "Only members of this project can discover and request this dataset",
    },
    org: {
      label: "Everyone in your organization",
      description:
        "All org members can see this dataset in the catalog and request access",
    },
    private: {
      label: "Hidden",
      description: "Not visible to anyone",
    },
  },
  downloadOptions: {
    none: {
      label: "Request required",
      description:
        "Researchers must submit a data request to access this dataset",
    },
    project: {
      label: "All project members",
      description:
        "Any member of this project can download directly (de-identified)",
    },
    selectedMembers: {
      label: "Selected members only",
      description:
        "Only specific project members you choose can download directly",
    },
  },
  catalogVisibility: {
    heading: "Catalog visibility — who can discover this dataset",
    helpTip:
      "Who can SEE that this dataset exists, and so ask for it. This is separate from who can download it: a dataset can be listed in the catalog while still requiring an approved request to read.",
  },
  downloadAccess: {
    heading: "Download access — who can download without a request",
    helpTip:
      "Who can READ the de-identified file straight away, with no request to approve. Everyone else who can see the dataset has to submit a data request first.",
    membersWhoCanDownload: "Project members who can download:",
    onlyYouCanDownload:
      "Only you can download. Select additional members to share access.",
  },
};

export default uploadScopeSelector;
